import languages from './languages';
import { LanguageFormats } from '../../types/i18n';

/**
 * Accepts `langCode` of any of the accepted I18n.LanguageFormats
 * @returns `languageKey`
 * @defaults `i18nKey`
 */
const formatLanguageKey = (langCode: string, returnFormat: LanguageFormats = 'i18nKey'): string => {
  // Remove anything after comma (ex: 'Portuguese, Brazil')
  const trimLangCode = langCode.replace(/,.*/, '');
  const i18nLanguage = Object.values(languages).find(lang => Object.values(lang).find(val => val === trimLangCode));

  return (i18nLanguage && i18nLanguage[returnFormat]) || trimLangCode;
};

export default formatLanguageKey;
